import "../_scss/app.scss";

import {InViewObserver, inViewObserver} from "./class/InViewObserver.js";
// import {PostIndex} from "./class/PostIndex.js";
// import Swiper from 'swiper';

import {smoothScroll} from "./modules/smoothScroll.js";
import {globalMenuToggle} from "./modules/globalMenuToggle.js";
import {toggleClass} from "./modules/toggleClass.js";
import {headerScroll} from "./modules/headerScroll.js";
import {aside} from "./modules/aside";
import {refineSearch} from "./modules/refineSearch.js";
import {initTopNews, initNewsList} from "./modules/news.js";

/**
 * 発火層
 */

document.addEventListener('DOMContentLoaded', () => {
	// asideBtn();
	smoothScroll({
		offset: () => window.matchMedia('(max-width: 768px)').matches ? 120 : 120,
		duration: 600,
		updateURL: 'replace'
	});
	globalMenuToggle();
	toggleClass([
		{selector: '.l-footer__menu__toggle',className:'js-open'}
	]);
	headerScroll(10);
	aside();
	refineSearch();
	initTopNews();
	initNewsList();

	const observer1 = new InViewObserver({
		offset: 200,
		exitOffset: 0,
		removeOnExit: true
	});
	// initAsideHiddenOnKeyVisual()
});


